@if (fieldData()?.readonly) {
    <cipo-text-view [config]="fieldData()" [value]="control().value" />
} @else if (control()) {
    @if (!fieldData()?.multiple) {
        <mat-form-field
            class="cipo--width--full"
            appearance="outline"
            [ngClass]="{
                'cipo-input': fieldData().appearanceFill,
                'cipo-mark-changed': fieldData().markChanged && valueChanged(),
            }">
            @if (fieldData()?.label) {
                <mat-label>{{ fieldData()?.label | translate }}</mat-label>
            }
            <input
                matInput
                #numberInput
                [thousandSeparator]="fieldData()?.showThousandSeparator"
                [decimals]="fieldData()?.decimals"
                [formControl]="numberControl"
                [placeholder]="fieldData()?.placeholder ?? '' | translate"
                (focus)="onFocus($event)"
                (blur)="onBlur($event)" />

            @if (fieldData()?.prefixIcon) {
                <mat-icon matPrefix>
                    {{ fieldData()?.prefixIcon }}
                </mat-icon>
            }
            @if (fieldData()?.prefix) {
                <span matTextPrefix class="cipo--text--pre">
                    {{ fieldData()?.prefix | translate }}
                </span>
            }

            @if (fieldData()?.suffix) {
                <span matTextSuffix class="cipo--text--pre">
                    {{ fieldData()?.suffix | translate }}
                </span>
            }
            @if (fieldData()?.suffixIcon) {
                <mat-icon matSuffix>
                    {{ fieldData()?.suffixIcon }}
                </mat-icon>
            }
            @if (canClearInput() && singleHasValue() && !numberControl.disabled) {
                <button
                    matSuffix
                    mat-icon-button
                    data-testid="cipo-number-input-clear"
                    [attr.aria-label]="'a11y.form.clearInput' | translate"
                    (click)="numberControl.setValue(null); clearValue()">
                    <mat-icon aria-hidden="true">close</mat-icon>
                </button>
            } @else if (fieldData()?.fieldDescription) {
                <mat-icon
                    matSuffix
                    data-testid="cipo-number-input-info"
                    class="material-icons-outlined cipo--cursor--help"
                    [title]="fieldData()?.fieldDescription | translate">
                    info
                </mat-icon>
            }
            @let error = errorMessage();
            @if (error || (numberControl.invalid && numberControl.touched)) {
                <mat-error>
                    {{ error ? (error.key | translate: error.params) : ("errors.required" | translate) }}
                </mat-error>
            }
            @if (fieldData()?.hint) {
                <mat-hint>{{ fieldData()?.hint | translate }}</mat-hint>
            }
        </mat-form-field>
    } @else {
        <mat-form-field
            class="cipo--width--full"
            appearance="outline"
            [ngClass]="{
                'cipo-input': fieldData().appearanceFill,
                'cipo-mark-changed': fieldData().markChanged && valueChanged(),
            }">
            @if (fieldData()?.label) {
                <mat-label>{{ fieldData()?.label | translate }}</mat-label>
            }
            @let r = range();
            <mat-chip-grid
                #chipGrid
                [formControl]="chipsField"
                class="cipo--overflow-y--auto"
                [style.maxHeight]="maxHeight()">
                @for (value of $any(control().value); track $index) {
                    <mat-chip-row
                        (removed)="remove($index)"
                        (click)="edit($index)"
                        [class.error]="(r?.hasMin && value < r?.min) || (r?.hasMax && value > r?.max)">
                        <span>
                            @if (fieldData()?.prefixIcon) {
                                <mat-icon inline>{{ fieldData()?.prefixIcon }}</mat-icon>
                            }
                            @if (fieldData()?.prefix) {
                                {{ fieldData()?.prefix | translate }}
                            }
                            {{ formatNumber(value) }}
                            @if (fieldData()?.suffix) {
                                {{ fieldData()?.suffix | translate }}
                            }
                            @if (fieldData()?.suffixIcon) {
                                <mat-icon inline>{{ fieldData()?.suffixIcon }}</mat-icon>
                            }
                        </span>
                        <button
                            matChipRemove
                            [attr.aria-label]="'a11y.form.removeChip' | translate: { value: formatNumber(value) }">
                            <mat-icon aria-hidden="true">cancel</mat-icon>
                        </button>
                    </mat-chip-row>
                }
                <input
                    #chipInput
                    [thousandSeparator]="fieldData()?.showThousandSeparator"
                    [decimals]="fieldData()?.decimals"
                    [matChipInputFor]="chipGrid"
                    [matChipInputAddOnBlur]="true"
                    autocomplete="off"
                    [placeholder]="fieldData()?.placeholder ?? '' | translate"
                    (matChipInputTokenEnd)="add($event)"
                    (blur)="onblur.emit()" />
            </mat-chip-grid>
            @let error = errorMessage();
            @if (error) {
                <mat-error>
                    {{ error.key | translate: error.params }}
                </mat-error>
            }
            @if (fieldData()?.hint) {
                <mat-hint>{{ fieldData()?.hint | translate }}</mat-hint>
            }
        </mat-form-field>
    }
}
